import { Controller } from '@hotwired/stimulus';

const $ = window.jQuery || window.$;

export default class extends Controller {
  static targets = ['form', 'select'];

  connect() {
    this.initializeSelect2();
    this.initializeFormValidation();
  }

  disconnect() {
    // Clean up Select2 instances when controller disconnects
    this.selectTargets.forEach(select => {
      if ($(select).data('select2')) {
        $(select).select2('destroy');
      }
    });
  }

  initializeSelect2() {
    this.selectTargets.forEach(select => {
      $(select).select2({
        theme: 'bootstrap-5',
        placeholder: select.dataset.placeholder || 'Select...',
        allowClear: true,
        width: '100%',
        minimumResultsForSearch: 0 // Always show search box
      });
    });
  }

  initializeFormValidation() {
    this.formTargets.forEach(form => {
      form.addEventListener('submit', (event) => {
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add('was-validated');
      });
    });
  }

  selectAll(event) {
    event.preventDefault();
    const selectId = event.currentTarget.dataset.selectId;
    const select = document.getElementById(selectId);
    if (select && select.multiple) {
      $(select).find('option').prop('selected', true);
      $(select).trigger('change');
    }
  }

  clearAll(event) {
    event.preventDefault();
    const selectId = event.currentTarget.dataset.selectId;
    const select = document.getElementById(selectId);
    if (select && select.multiple) {
      $(select).val(null).trigger('change');
    }
  }
}